import { motion } from "framer-motion";
import "./Approach.css";

interface ApproachItem {
  step: number;
  title: string;
  description: string;
}

interface ApproachProps {
  title: string;
  backgroundImage: string;
  items: ApproachItem[];
}

const gridVariants = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.15 },
  },
};

const cardVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] as const },
  },
};

const Approach = ({ title, backgroundImage, items }: ApproachProps) => {
  return (
    <section
      className="approach-section"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="approach-overlay" />

      <div className="approach-container container">
        <motion.h2
          className="approach-title"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.6 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
        >
          {title}
        </motion.h2>

        <motion.div
          className="approach-grid"
          variants={gridVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.15 }}
        >
          {items.map((item) => (
            <motion.div
              className="approach-card"
              key={item.step}
              variants={cardVariants}
              whileHover={{ y: -8 }}
              transition={{ type: "spring", stiffness: 300, damping: 20 }}
            >
              <motion.div
                className="approach-step"
                whileHover={{ scale: 1.15, rotate: 8 }}
                transition={{ type: "spring", stiffness: 300, damping: 12 }}
              >
                {item.step}
              </motion.div>
              <h4>{item.title}</h4>
              <p>{item.description}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Approach;
